// extracted by mini-css-extract-plugin
export default {"cls1":"WhoCanSeePost-cls1_JL6","cls2":"WhoCanSeePost-cls2_M6p WhoCanSeePost-cls1_JL6"};